import { NgModule } from "@angular/core";
import { CoreModule } from "../../core/core.module";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedElementsModule } from "../shared/shared-elements.module";
import { UserChangeEmailDialogComponent } from "./change-email-dialog/elements-user-change-email-dialog.component";
import { ElementsUserEditComponent } from "./edit-dialog/elements-user-edit-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        PipesModule,
        SharedElementsModule,
        ElementsUserEditComponent,
        UserChangeEmailDialogComponent,
    ],
    exports: [ElementsUserEditComponent, UserChangeEmailDialogComponent],
})
export class UserElementsModule {}
